import React from 'react'
import Header from '../Components/Header';
import Hero from '../Components/Hero';
import ProjectType from '../Components/ProjectType';
import Footer from '../Components/Footer';

export default function Home () {
    return(
        <div>
            <Header />
            <Hero />
            <ProjectType />
            <div className='flex items-center flex-col justify-center gap-4 mt-40'>
                <h1 className='text-[2rem] font-[800]'>START AI TEAMS JOURNEY</h1>
                <p className='text-[1.1rem] text-[#6B7280]'>A Platform to Distribute & Orchestrate Between Al Teams</p>
                <button className='w-[7.3rem] h-[2.6rem] bg-[#942A27] rounded-[8px] text-white font-[500] text-[0.95rem] mt-2'>Get Started</button>
            </div>
            <Footer />
        </div>
    );
}